import AuthAPI from "@/services/config/Auth";
import Util from "./Util";

export default () => {
  const { sair } = AuthAPI();
  const { getClienteFromUrl } = Util();

  function verificaUsuarioLogado(cliente = null) {
    if (cliente == null) {
      cliente = getClienteFromUrl();
    }
    const userString = localStorage.getItem(`cliente-${cliente.toUpperCase()}`);
    if (userString) {
      const user = JSON.parse(userString);
      const expiraToken = user.expira;
      return new Date(expiraToken) > new Date();
    }
    return false;
  }

  function getUserTokenExpiresDate() {
    const user = getUserFromLocalStorage();
    return user ? new Date(user.expira) : false;
  }

  function getNomeUsuarioLogado() {
    const user = getUserFromLocalStorage();
    return user.nomeUsuario;
  }

  function isUserInRole(role) {
    role = role.toUpperCase();
    const user = getUserFromLocalStorage();
    return user.roles.includes(role) || false;
  }

  function getUserFromLocalStorage(cliente = null) {
    if (!cliente) {
      cliente = getClienteFromUrl();
    }
    return JSON.parse(localStorage.getItem(`cliente-${cliente.toUpperCase()}`));
  }

  function logout() {
    const cliente = getClienteFromUrl();
    sair()
      .then(() => {
        localStorage[`cliente-${cliente.toUpperCase()}`] = "";
        window.location.reload();
      })
      .catch(e => {
        console.log(e);
      });
  }

  return {
    verificaUsuarioLogado,
    logout,
    getNomeUsuarioLogado,
    isUserInRole,
    getUserTokenExpiresDate
    
  };
};
